"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _reactStickynode = _interopRequireDefault(require("react-stickynode"));

var styles = {
  leftSectionIntents: {
    paddingTop: function paddingTop(_ref) {
      var spacing = _ref.spacing;
      return spacing(5);
    }
  },
  mainSectionIntents: {
    padding: function padding(_ref2) {
      var spacing = _ref2.spacing;
      return spacing(5, 6, 0, 1.5);
    }
  }
};

var Layout2Columns = function Layout2Columns(_ref3) {
  var leftSection = _ref3.leftSection,
      children = _ref3.children,
      _ref3$indented = _ref3.indented,
      indented = _ref3$indented === void 0 ? true : _ref3$indented,
      _ref3$stickySection = _ref3.stickySection,
      stickySection = _ref3$stickySection === void 0 ? false : _ref3$stickySection,
      stickyBoundaryTop = _ref3.stickyBoundaryTop,
      sx = _ref3.sx;
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    sx: sx
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 3,
    lg: 2,
    sx: [indented && !stickySection && styles.leftSectionIntents]
  }, stickySection && leftSection ? /*#__PURE__*/_react.default.createElement(_reactStickynode.default, {
    top: "#".concat(stickyBoundaryTop)
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: [indented && styles.leftSectionIntents]
  }, leftSection)) : leftSection), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 9,
    lg: 10,
    sx: [indented && styles.mainSectionIntents]
  }, children));
};

var _default = Layout2Columns;
exports.default = _default;